/* eslint-disable import/first */
import { addLocaleData } from "react-intl";
const DEFAULT_LOCALE = "en";

import ar from "react-intl/locale-data/ar";
import cs from "react-intl/locale-data/cs";
import da from "react-intl/locale-data/da";
import de from "react-intl/locale-data/de";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import fi from "react-intl/locale-data/fi";
import fr from "react-intl/locale-data/fr";
import hu from "react-intl/locale-data/hu";
import is from "react-intl/locale-data/is";
import it from "react-intl/locale-data/it";
import ja from "react-intl/locale-data/ja";
import nl from "react-intl/locale-data/nl";
import no from "react-intl/locale-data/no";
import pt from "react-intl/locale-data/pt";
import sv from "react-intl/locale-data/sv";
import tr from "react-intl/locale-data/tr";
import zh from "react-intl/locale-data/zh";

import arMessages from "./ar.json";
import csMessages from "./cs.json";
import daMessages from "./da.json";
import deMessages from "./de.json";
import enMessages from "./en.json";
import esMessages from "./es.json";
import fiMessages from "./fi.json";
import frMessages from "./fr.json";
import huMessages from "./hu.json";
import isMessages from "./is.json";
import itMessages from "./it.json";
import jaMessages from "./ja.json";
import nlMessages from "./nl.json";
import noMessages from "./no.json";
import ptMessages from "./pt.json";
import svMessages from "./sv.json";
import trMessages from "./tr.json";
import zhMessages from "./zh.json";

addLocaleData([
  ...ar,
  ...cs,
  ...da,
  ...de,
  ...en,
  ...es,
  ...fi,
  ...fr,
  ...hu,
  ...is,
  ...it,
  ...ja,
  ...nl,
  ...no,
  ...pt,
  ...sv,
  ...tr,
  ...zh
]);

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enMessages)
      : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    let message = messages[key];
    if (!message && locale !== DEFAULT_LOCALE) {
      message = defaultFormattedMessages[key];
    }
    return Object.assign(formattedMessages, {
      [key]: message
    });
  }, {});
};

export const translationMessages = {
  ar: formatTranslationMessages("ar", arMessages),
  cs: formatTranslationMessages("cs", csMessages),
  da: formatTranslationMessages("da", daMessages),
  de: formatTranslationMessages("de", deMessages),
  en: formatTranslationMessages("en", enMessages),
  es: formatTranslationMessages("es", esMessages),
  fi: formatTranslationMessages("fi", fiMessages),
  fr: formatTranslationMessages("fr", frMessages),
  hu: formatTranslationMessages("hu", huMessages),
  is: formatTranslationMessages("is", isMessages),
  it: formatTranslationMessages("it", itMessages),
  ja: formatTranslationMessages("ja", jaMessages),
  nl: formatTranslationMessages("nl", nlMessages),
  no: formatTranslationMessages("no", noMessages),
  pt: formatTranslationMessages("pt", ptMessages),
  sv: formatTranslationMessages("sv", svMessages),
  tr: formatTranslationMessages("tr", trMessages),
  zh: formatTranslationMessages("zh", zhMessages)
};
